import React from "react";

import { Grid, Row, Col, css, styled, thd, up } from "@smooth-ui/core-sc";
import bannerDesktop from "./images/hero-banner-@1x.png";
import bannerDesktop2x from "./images/hero-banner-@2x.png";

const BannerWrapper = styled.div`
  position: relative;
  z-index: -1;
`;

const BannerContainer = styled.div`
  background-image: url(${bannerDesktop});
  align-items: center;
  background-color: ${thd("primary", "#00A7AD")};
  background-position: left center;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  height: 250px;
  justify-content: flex-start;

  @media only screen and (min-device-pixel-ratio: 1.5),
    only screen and (min-resolution: 144dpi),
    only screen and (min-resolution: 1.5dppx) {
    background-image: url(${bannerDesktop2x});
  }

  .banner__title {
    color: #fff;
    font-size: 60px;
    font-weight: bold;
    line-height: 1.1;
    margin: 0;
    padding: 0;
    position: relative;
    text-align: center;
  }
  .banner {
    height: 150px;
  }
  ${up(
    "sm",
    css`
      background-image: url(${bannerDesktop});
      background-position: center center;
      height: 275px;

      @media only screen and (min-device-pixel-ratio: 1.5),
        only screen and (min-resolution: 144dpi),
        only screen and (min-resolution: 1.5dppx) {
        background-image: url(${bannerDesktop2x});
      }

      .banner {
        height: 275px;
      }
    `,
  )}
  ${up(
    "lg",
    css`
      background-image: url(${bannerDesktop});
      background-position: center center;
      height: 538px;

      @media only screen and (min-device-pixel-ratio: 1.5),
        only screen and (min-resolution: 144dpi),
        only screen and (min-resolution: 1.5dppx) {
        background-image: url(${bannerDesktop2x});
      }

      .banner {
        height: 300px;
      }
    `,
  )}
`;

const HeroBanner = (props) => (
  <BannerWrapper className="banner-wrapper">
    <BannerContainer {...props}>
      <Grid>
        <Row alignItems="center" className="banner">
          <Col xs={12} md={8} lg={8} olg={2} className="banner__title__wrapper">
            <p className="banner__title">&nbsp;</p>
          </Col>
        </Row>
      </Grid>
    </BannerContainer>
  </BannerWrapper>
);

export default HeroBanner;
